import { type OptionsType } from "@/components/form/selectField";
import { useMemo } from "react";
import { MASTER_DATA } from "../constants/endpoint";
import useFetchList from "./useFetchList";

// TODO: update ststus_name if backend change it
type MotorcycleRentStatus = {
  description: string;
  id: number;
  no: number;
  status_name: "RENT_UNAVAILABLE" | "RENT_AVAILABLE" | (string & {});
};

type FetchListType = {
  page_count: number;
  row_count: number;
  rows: MotorcycleRentStatus[];
};

const useFetchMotorcycleRentStatus = (enable = false) => {
  const {
    data: motorcycleRentStatus,
    isLoading,
    isError,
  } = useFetchList<FetchListType>(
    {
      page_number: 1,
      page_size: 25,
      sort_by: "id" as const,
      sort_direction: "ASC" as const,
    },
    MASTER_DATA.MOTORCYCLE_GET_RENT_STATUS,
    {
      enabled: enable,
    }
  );

  // const motorcycleRentStatusOptions: OptionsType[] = useMemo(() => {
  //   if (!isLoading && motorcycleRentStatus) {
  //     return motorcycleRentStatus.rows.map((item) => ({
  //       value: String(item.id),
  //       label: `${item.status_name} - ${item.description}`,
  //     })) as unknown as OptionsType[];
  //   } else {
  //     return [];
  //   }
  // }, [motorcycleRentStatus]);

  const motorcycleRentStatusOptions: OptionsType[] = useMemo(() => {
    if (!isLoading && motorcycleRentStatus) {
      return motorcycleRentStatus.rows.map((item) => {
        const normalizedStatus = item.status_name
          .replace(/_/g, " ")
          .toLowerCase(); // motor bekas

        const searchValue = [
          item.status_name, // ex: MOTOR_BEKAS
          normalizedStatus, // motor bekas
          item.description, // deskripsi (ID)
        ]
          .join(" ")
          .toLowerCase();

        return {
          value: String(item.id),
          label: `${item.status_name} - ${item.description}`,
          searchValue,
        };
      });
    }

    return [];
  }, [motorcycleRentStatus, isLoading]);

  return { motorcycleRentStatusOptions, isLoading, isError };
};

export default useFetchMotorcycleRentStatus;
